import { Component, OnInit, OnDestroy } from '@angular/core';
import { ChangePassword } from '../../../models/ChangePassword';
import { AccountService } from '../../../services/account.service';
import { ActivatedRoute, Router } from '@angular/router';
import { NgForm } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';

@Component({
  selector: 'app-changepwd',
  templateUrl: './changepwd.component.html',
  styleUrls: ['./changepwd.component.scss']
})
export class ChangepwdComponent implements OnInit, OnDestroy {
  public showSuccessConfirmation = false;
  public showFailConfirmation = false;
  public changePwd: ChangePassword = new ChangePassword();
  public successMsg: string;
  public errorMsg: string;
  public isComparePasswordMatched = true;
  alive = true;
  constructor(private accountSvc: AccountService,
    private route: ActivatedRoute,
    private router: Router,
    private spinner: NgxSpinnerService) {
      this.route.queryParams.subscribe( params => {
        this.changePwd.LID = params['id'];

         this.changePwd.bearerToken = params['token'];
         this.changePwd.Universalemail = params['univEmail'];
      });
    }

  ngOnInit() {






  }

  onSubmit(frmChangePwd: NgForm) {
    this.errorMsg = null;
    this.successMsg = null;
    this.spinner.show();
    console.log(this.changePwd);
    this.accountSvc.changePassword(this.changePwd)
    .takeWhile(() => this.alive)
    .subscribe(
      data => {
                this.spinner.hide();
                this.showSuccessConfirmation = true;
                this.showFailConfirmation = false;
                this.successMsg = 'You have successfully updated your password.';
                this.errorMsg = null;
                this.changePwd = new ChangePassword();
                frmChangePwd.reset();
            },
      error => {
          this.spinner.hide();
          this.showSuccessConfirmation = false;
          this.showFailConfirmation = true;
          this.successMsg = null;
          this.errorMsg = error._body;
        }
    );
   // window.scrollTo(0, 0);
  }

  redirectToLogin(event) {

    this.router.navigate(['/pages/login']);
  }

  close() {
    this.showFailConfirmation = false;
    this.showSuccessConfirmation = false;
  }

  comparePasswords(frmChangePwd: NgForm) {
    if (this.changePwd.NewPassword === this.changePwd.ConfirmNewPassword) {
      frmChangePwd.controls['changePwd.ConfirmNewPassword'].setErrors(null);
      this.isComparePasswordMatched = true;
    } else {
      frmChangePwd.controls['changePwd.ConfirmNewPassword'].setErrors({'incorrect' : true});
      this.isComparePasswordMatched = false;
    }
  }

  ngOnDestroy() {
    this.alive = false;
  }

}



// WEBPACK FOOTER //
// ./src/app/pages/account/changepwd/changepwd.component.ts